import { useTonConnectUI } from '@tonconnect/ui-react';

import { AppRoute } from '@/common/app/routes';
import { useUnregisterPush } from '@/common/hooks/push-notifications';
import { loggedOut } from '@/redux/reducers/userReducer';
import { useAppDispatch } from '@/redux/store';

const useLogout = (): (() => Promise<void>) => {
  const dispatch = useAppDispatch();
  const [tonConnectUI] = useTonConnectUI();
  const unregisterPush = useUnregisterPush();

  return async () => {
    try {
      await tonConnectUI.disconnect();
    } catch {
      // wallet may not be connected
    }
    // while still authorized: this device must stop getting the account's pushes
    await unregisterPush();
    localStorage.removeItem('auth_token');
    dispatch(loggedOut());
    // Full reload, not navigate: loggedOut clears only the token, while the
    // store slices, RTK Query cache and hook refs keep the previous account —
    // the next account in the native app saw its arena league, rewards, etc.
    window.location.replace(AppRoute.LOGIN);
  };
};

export { useLogout };
